import { call, put, takeLatest } from 'redux-saga/effects';
import * as Actions from './actions';
import * as Apis from './service';

export function* getUserProfile() {
  try {
    const data = yield call(Apis.retrieveUserProfile);
    yield put(Actions.setUserProfile(data));
  } catch (error) {
    yield put(Actions.userProfileRetrievalFailed(error));
  }
}

export function* watchGetUserProfile() {
  yield takeLatest(Actions.UserProfileActionTypes.USER_PROFILE_INIT, getUserProfile);
}
